import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractFieldInputTypeHandlerComponent,
  FormValueReadableValue
} from "../../type-handler/abstract-field-input-type-handler.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  FormDefinitionFieldModel
} from "../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model";
import {FormValueModel} from "../../../../../../modules/form/form/value/api/entity/formValue.model";
import {
  VideoAnalysisCategoriesData,
  VideoAnalysisComponent, VideoAnalysisData
} from "../../../../../../modules/common/video/video-analysis/video-analysis.component";
import {ImageHelper} from "../../../../../../modules/common/image/imageHelper";
import {Base64Utils} from "../../../../../../modules/core/utils/base64.utils";
import {
  FormValueSummaryFieldModule
} from "../../../../../../modules/form/form/value/api/component/form-value-summary-field/form-value-summary-field.module";
import {FormSummaryValueModel} from "../../../../../../modules/form/form/api/entity/formSummaryValue.model";
import {
  FormDefinitionFieldType
} from "../../../../../../modules/form/definition/field/api/entity/formDefinitionFieldSummary.model";

@Component({
  selector: 'app-video-analysis-field-input-type-handler',
  standalone: true,
  imports: [CommonModule, VideoAnalysisComponent, FormValueSummaryFieldModule],
  templateUrl: './video-analysis-field-input-type-handler.component.html',
  styles: [
  ]
})
export class VideoAnalysisFieldInputTypeHandlerComponent extends AbstractFieldInputTypeHandlerComponent<FormGroup> {
  categoriesData: VideoAnalysisCategoriesData;
  data: VideoAnalysisData;

  public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
    if (!value) {
      return Promise.resolve([]);
    }
    const parsed = JSON.parse(value as string);
    const promises: Promise<FormValueReadableValue>[] = parsed.pictures
        .filter((picture: any) => picture.backgroundImage)
        .map((picture: any) => {
          if (!picture.image) {
            return Promise.resolve(FormValueReadableValue.ofImage(picture.backgroundImage));
          } else {
            return ImageHelper.combineImagesFromBase64(picture.backgroundImage, picture.image)
                .then(blob => Base64Utils.blobToBase64(blob))
                .then(base64 => FormValueReadableValue.ofImage(base64))
                .catch(() => FormValueReadableValue.ofText('Une erreur est survenue'));
          }
        });

    return Promise.all(promises);
  }

  existingFormValue: FormSummaryValueModel;

  constructor(private formBuilder: FormBuilder) {
    super();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): FormGroup {
    if (formDefinitionField.data) {
      this.categoriesData = JSON.parse(formDefinitionField.data);
    }
    return this.formBuilder.group({
      value: this.formBuilder.control(undefined),
    });
  }

  initiateForm(formValue: FormValueModel): void {
    this.formValue = undefined;
    if (formValue.value) {
      this.jsonControl.get('value').setValue(formValue.value);
      console.log('value', formValue.value);



      this.existingFormValue = {
        value: formValue.value,
        typeValue:  FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_VIDEO_ANALYSIS,
        subTypeValue: undefined,
        comment: formValue.comment,
        document: undefined,
        label: undefined,
        defaultValue: undefined,
        unit: undefined,
        options: undefined
      }
    }
  }

  synchronizeValue(): string {
    return this.jsonControl.get('value').value;
  }

  changed(event: VideoAnalysisData) {
    this.data = event;
    this.jsonControl.get('value').setValue(JSON.stringify({
      pictures: event.pictures.map(value => {
        return {
          time: value.time,
          categoryName: value.categoryName,
          backgroundImage: value.backgroundImage,
          image: value.drawingData?.image,
          data: {
            items: ! value?.drawingData?.drawingData?.items ? [] : value.drawingData.drawingData.items.map(value => {
              return {
                typeValue: value.typeValue,
                subTypeValue: value.subTypeValue,
                common: {
                  thickness: value.common.thickness,
                  color: value.common.color,
                  size: value.common.size,
                  label: value.common.label,
                  name: value.common.name
                },
                properties: value.properties
              }
            })
          }

        }
      })
    }));
  }
  synchronizeRuleValue(): string {
    return this.data ? JSON.stringify({
      pictures: this.data.pictures.map(picture => {
        return {
          time: picture.time,
          categoryName: picture.categoryName,
          data: {
            items: picture.drawingData.drawingData.items.map(value => {
              return {
                typeValue: value.typeValue,
                subTypeValue: value.subTypeValue,
                common: {
                  thickness: value.common.thickness,
                  color: value.common.color,
                  size: value.common.size,
                  label: value.common.label,
                  name: value.common.name
                },
                properties: value.properties
              }
            })
          }
        }
      })
      }) : "";
  }

}
